
<!-- DEPRECATED -->

<template>
  <div class="container_log">
    <b-container class="header">
      <b-row>
        <b-col>
          <div @click="gotToPath('/home')" style="cursor:pointer;margin-top:20px;">
            <font-awesome-icon style="font-size:28px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="form_container">
        <b-col cols="12" style="height:50px;text-align:center;color:#2C2A29;font-size:16px;font-weight: 500;">
          ESQUECI MINHA SENHA
        </b-col>
        <b-col cols="12" style="height:50px;">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'envelope']" :style="{color: getCssColor('secondary_bt')}"/>
          <input type="text" autocapitalize="none" class="inputFormText" name="email" placeholder="E-mail" v-model="email"/>
        </b-col>
        <b-col cols="12" style="height:100px;">
          <div @click="resendCodeToForgot()" :style="{backgroundColor: getCssColor('secondary_bt')}"
            style="margin-top:40px;color:#FFFFFF; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
            CONTINUAR
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
import colors from '@/mixins/colors'
import UserConn from '@/connection/user'
import { EventBus } from '@/behaviours/event-bus'

export default {
  name: 'Forgot',
  data () {
    return {
      email: null
    }
  },
  mixins: [navigation, colors],

  methods: {
    async resendCodeToForgot () {
      if (this.email) {
        localStorage.setItem('tryValidationEmail', this.email)
        let result = await UserConn.resendValidationCode()
        if (!result.error) {
          // TODO remove origin to navigation
          this.$store.state.validationOrigin = 'forgot'
          this.$store.state.tempId = result.userId
          this.$router.push({path:'/validation'})
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.form_container {
  position:relative;
  width: calc(100%);
  max-width:434px;
  line-height: 20px;
  margin: 0px auto;
}
.container_log {
  width:100vw;
  // max-width: 1330px;
  min-height: 100vh;
  background-color: #FFFFFF;
}
.header{
  width : 100vw;
  // max-width: 1330px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  height: 46px;
  text-align:right;
  top: 10px;
}

.content_form {
  padding:10px 20px;
}

.inputFormText {
    width: calc(100%);
    font-size:16px;
    height:30px;
    padding-left:30px;
    color: #2C2A29;
    background-color: transparent;
    border:0px;
    border-bottom: 1px solid #2C2A29;
  }
.imgInputIcon {
    position:relative;
    left:5px;
    top:26px;
    font-size:16px;
  }

  .imgSelectIcon {
    font-size:16px;
    margin-left:5px;
  }

  input::placeholder {
    font-size:16px;
    //color: #2C2A29;
  }

  input:focus {
    outline: none;
    border:0px;
    border-bottom: 1px solid #5E2B8B;
  }
</style>

